import { bootstrap } from 'bootstrap';
// import { Tooltip, Toast, Popover } from 'bootstrap';
import selectors from './constants.js';
import Carousel from "../components/carousel/carousel.js";
import CarouselSingle from "../components/carousel-quote/carousel-quote.js";
import LangSelect from "../components/lang-select/lang-select.js";

if (document.querySelector(selectors.carousel)) {
  let carousel = new Carousel();
  carousel.init();
}

if (document.querySelector(selectors.carouselQuote)) {
  let carouselSingle = new CarouselSingle();
  carouselSingle.init();
}

if (document.querySelector(selectors.langSelect)) {
  let langSelect = new LangSelect();
  langSelect.init();
}